import { Input } from '@mm/components';
import { StoreState } from '@mm/state/store-interfaces';
import { WidgetTypes } from '@mm/state/model/WidgetModel';
import { useResolutionInfo } from '@mm/hooks';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { DialoguePreview } from '../../../../../modules/DailoguePreview/DialoguePreview';
import { EmbeddableDialogueEditor } from './EmbeddableDialogueEditor';
import styles from './EmbeddableDialogueEditorWithPreview.module.css';
import { WidgetAlerts } from './WidgetByType/WidgetByType';
import { MOBILE_THRESHOLD } from '../../../../constants/screenSize';
import { PlatformType } from '@mm/state/model/CampaignsModel';
import AdConfigModel from '@mm/state/model/AdConfigModel';

interface Props {
  className?: string;
  dialogueId: number | undefined;
  usedInSlideout?: boolean;
  dialogueEditorClassName?: string;
  editPaneClassname?: string;
  previewClassName?: string;
  hideDialogueSelector?: boolean;
  widgetsToExclude?: WidgetTypes[];
  forInstagram?: boolean;
  showAttributesStartWarning?: boolean;
  firstWidgetNotAllowedWarning?: WidgetAlerts;
  disableFirstWidgetConditionalLogic?: boolean;
  withPreview?: boolean;
  platforms?: PlatformType[];
  forAds?: boolean;
  adConfig?: AdConfigModel | null;
  isDisabled?: boolean;
}

export const EmbeddableDialogueEditorWithPreview = ({
  dialogueId,
  usedInSlideout,
  className,
  editPaneClassname,
  dialogueEditorClassName,
  hideDialogueSelector,
  previewClassName,
  widgetsToExclude,
  forInstagram,
  showAttributesStartWarning,
  firstWidgetNotAllowedWarning,
  disableFirstWidgetConditionalLogic,
  withPreview,
  platforms,
  forAds,
  adConfig,
  isDisabled,
}: Props) => {
  const dialogue = useSelector((state: StoreState) =>
    state.page.entities.find(p => p.id === dialogueId),
  );

  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_THRESHOLD;

  if (!dialogueId) {
    return null;
  }
  return (
    <div className={classNames(styles.container, className)}>
      <div className={classNames(styles.editPane, editPaneClassname)}>
        {!hideDialogueSelector && (
          <div className={styles.dialogueName}>
            <div>Dialogue:</div>{' '}
            <Input
              css={{
                container: styles.dialogueNameInputContainer,
                input: styles.dialogueNameInput,
              }}
              disabled
              value={dialogue?.name}
            />
          </div>
        )}
        <EmbeddableDialogueEditor
          className={classNames(styles.dialogueEditor, dialogueEditorClassName)}
          dialogueId={dialogueId}
          usedInSlideout={usedInSlideout}
          widgetsToExclude={widgetsToExclude}
          forInstagram={forInstagram}
          showAttributesStartWarning={showAttributesStartWarning}
          firstWidgetNotAllowedWarning={firstWidgetNotAllowedWarning}
          disableFirstWidgetConditionalLogic={
            disableFirstWidgetConditionalLogic
          }
          platforms={platforms}
          forAds={forAds}
          adConfig={adConfig}
          isDisabled={isDisabled}
        />
      </div>
      {withPreview && !isMobile && (
        <div className={classNames(styles.previewPane, previewClassName)}>
          <DialoguePreview
            dialogueId={dialogueId}
            className={styles.dialoguePreview}
            sticky
          />
        </div>
      )}
    </div>
  );
};
